import { importLibrary, setOptions } from "@googlemaps/js-api-loader";

export class GoogleMapLoader {
  /**
   * Configure the Google Maps JavaScript API and load the libraries the map code relies on.
   *
   * Resolves with the global `google` namespace once `google.maps`, `google.maps.geometry` and
   * `google.maps.places` are available (the map, layer and routing code addresses them globally).
   *
   * @returns {Promise<typeof google>}
   */
  static async loadGoogleMapsApi() {
    setOptions({
      // eslint-disable-next-line no-undef
      key: process.env.API_KEY,
      // eslint-disable-next-line no-undef
      v: process.env.VERSION,
      // Pin the API language so Directions step texts, place names etc. do not follow the
      // browser locale (the application is English-only and step texts feed the route risk trace).
      language: "en",
    });
    await Promise.all([importLibrary("maps"), importLibrary("geometry"), importLibrary("places")]);
    return window.google;
  }
}
